var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jump"},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif"),"alt":""}}),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMsg),expression:"errorMsg"}],staticStyle:{"color":"#F56C6C","font-size":"15px"}},[_vm._v("错误提示: "+_vm._s(_vm.errorMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }